module.exports = __webpack_public_path__ + "img/wph.e827255d.png";